
import React, { useContext } from 'react';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import Login from './Login';

function RequiresAuth ( { children } ) 
{
    const { currentUser } = useContext ( CurrentUserContext );

    const onSuccess = () => {};
    
    if ( currentUser === null )
    {
        return <Login onSuccess={() => onSuccess ()} />
    }
    else
    {
        return  <>
                    {children}
                </>
    }
}

export default RequiresAuth;
